
export default {
  name: 'SectionsTestimonial',
  props: {
    sectionTestimonials: {
      type: Object,
      default: () => {},
    },
  },
}
